<div>
    <p class="extra" (click)="toggleDeveloperMode()">
        {{ version }}
    </p>
</div>
